import React from 'react';

const retryImport = (factory, retries = 3, interval = 400) =>
  factory().catch(error => {
    if (retries <= 0) throw error;
    return new Promise(resolve => setTimeout(resolve, interval)).then(() =>
      retryImport(factory, retries - 1, interval)
    );
  });

export const lazyImport = (factory, name) =>
  React.lazy(() =>
    retryImport(factory).then(module => ({
      default: module[name],
    }))
  );
